module.exports = __webpack_public_path__ + "static/media/check_mark_circle.01084c13.svg";